import { downloadFile, formatDate, generateBlob } from '@chilecompra/react-kit'
import {
  LEGAL_DOCUMENT_NAMES_DICTIONARY,
  LEGAL_DOCUMENT_NAMES_TRANSLATION_DICTIONARY
} from '../../config/settings/constant'
import { makeActionCreator } from '../../config/store/utils'
import { downloadLegalDocumentFile, getSellerLegalDocuments } from '../../services/attachments'

export const DOWNLOAD_LEGAL_DOCUMENTS = 'DOWNLOAD_LEGAL_DOCUMENTS'
export const DOWNLOAD_LEGAL_DOCUMENTS_ERROR = 'DOWNLOAD_LEGAL_DOCUMENTS_ERROR'
export const DOWNLOAD_LEGAL_DOCUMENTS_SUCCESS = 'DOWNLOAD_LEGAL_DOCUMENTS_SUCCESS'
export const onDownloadLegalDocuments = makeActionCreator(DOWNLOAD_LEGAL_DOCUMENTS, 'payload')
export const onDownloadLegalDocumentsError = makeActionCreator(DOWNLOAD_LEGAL_DOCUMENTS_ERROR, 'payload')
export const onDownloadLegalDocumentsSuccess = makeActionCreator(DOWNLOAD_LEGAL_DOCUMENTS_SUCCESS, 'payload')
export const onDownloadLegalDocumentsThunk =
  ({ code, fileName }) =>
  async (dispatch, getState) => {
    const { currentDownload } = getState().legalDocuments
    dispatch(onDownloadLegalDocuments({ ...currentDownload, [code]: true }))
    try {
      const { downloadedFiles } = getState().legalDocuments
      if (downloadedFiles[code]) {
        downloadFile(downloadedFiles[code], fileName)
        return dispatch(onDownloadLegalDocumentsSuccess({ downloadedFiles, code }))
      }

      const { data, headers } = await downloadLegalDocumentFile({ code })
      const blob = generateBlob(data, headers['content-type'])

      downloadFile(blob, fileName)
      return dispatch(
        onDownloadLegalDocumentsSuccess({
          downloadedFiles: {
            ...downloadedFiles,
            [code]: blob
          },
          code
        })
      )
    } catch (error) {
      return dispatch(onDownloadLegalDocumentsError({ error, code }))
    }
  }

export const GET_SELLER_LEGAL_DOCUMENTS = 'GET_SELLER_LEGAL_DOCUMENTS'
export const GET_SELLER_LEGAL_DOCUMENTS_ERROR = 'GET_SELLER_LEGAL_DOCUMENTS_ERROR'
export const GET_SELLER_LEGAL_DOCUMENTS_SUCCESS = 'GET_SELLER_LEGAL_DOCUMENTS_SUCCESS'
export const onGetSellerLegalDocuments = makeActionCreator(GET_SELLER_LEGAL_DOCUMENTS)
export const onGetSellerLegalDocumentsError = makeActionCreator(GET_SELLER_LEGAL_DOCUMENTS_ERROR)
export const onGetSellerLegalDocumentsSuccess = makeActionCreator(GET_SELLER_LEGAL_DOCUMENTS_SUCCESS, 'payload')
export const onGetSellerLegalDocumentsThunk = payload => async dispatch => {
  dispatch(onGetSellerLegalDocuments())

  try {
    const {
      data: {
        payload: { documentos: documents }
      }
    } = await getSellerLegalDocuments({
      actionType: GET_SELLER_LEGAL_DOCUMENTS,
      dni: payload.userType === 'Comprador' ? payload.dni : undefined
    })

    return dispatch(
      onGetSellerLegalDocumentsSuccess({
        documents: documents.map(document => {
          return {
            belongsToEE1D: document.folio === -1,
            folio: document.folio,
            name: document.nombre,
            validityDate: formatDate(document.fechaVigencia, 'dd-MM-yyyy'),
            uploadedDate: formatDate(document.fechaCarga, 'dd-MM-yyyy'),
            url: document.urlDoc,
            type: document.tipo,
            state: document.estado,
            description:
              LEGAL_DOCUMENT_NAMES_DICTIONARY[LEGAL_DOCUMENT_NAMES_TRANSLATION_DICTIONARY[document.tipo]] ||
              document.descripcion
          }
        })
      })
    )
  } catch (error) {
    // FIXME: this checks should goes inside the factoryService implementation.
    // It will be fixed in v2 of react-kit.
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }

    return dispatch(onGetSellerLegalDocumentsError())
  }
}
